export const ROOF_TYPES = [
  { value: 'flat', label: 'Flat Roof' },
  { value: 'gabled', label: 'Gabled Roof' },
];

export function roofTypeLabel(value) {
  return ROOF_TYPES.find(type => type.value === value)?.label || 'Not selected';
}
